import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('orders/featureFlag', ['allFlags']),
  },
};
